import * as actionType from "../Actions/Action_Type";
import * as ROLES from "../Utils/Roles_Types.js";

const initialState = {
    isFetching              : false,
    pesateList              : [],
    errorMessage            : null,
    isAuthenticated         : true,
    impiantiList            : [],
    aziendeList             : [],
    campiPersonalizzatiList : [],
    listaFiltri             : [],
    dialogFilterOpened      : false,
    logicalOperators        : [],
    detailDialogOpened      : false,
    detailDialogPesata      : null,
    downloadDialogOpened    : false,
    fileTypeList            : []
};

const pesataReducer = (state = initialState, action) => {
    switch (action.type){
        case actionType.SHOW_LOADER:
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_PESATE_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_PESATE_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching      : false,
                pesateList      : typeof action.response === 'undefined' ? [] : action.response,
                isAuthenticated : true
            })
        case actionType.SERVICE_PESATE_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        case actionType.SERVICE_PESATE_REFRESH_LIST :
            return Object.assign({}, state, {
                isFetching : false,
                pesateList : action.newList
            })
        //RECUPERO I DATI DELL'UTENTE
        case actionType.SERVICE_USERINFO_REQUEST :
        return Object.assign({}, state, {
            isFetching : true,
        })
        case actionType.SERVICE_USERINFO_SUCCESS :
        var response = action.response;
        //salvo i dati dell'utente
        if(response.hasOwnProperty("IDUser") && response.hasOwnProperty("Username") && response.hasOwnProperty("Role")){
            localStorage.setItem(ROLES.USERINFO_KEY, JSON.stringify(response));
            return Object.assign({}, state, {
            isFetching      : false,
            isAuthenticated : action.authenticated || false,
            userInfo        : response
            })
        }else{
            return Object.assign({}, state, {
            isFetching      : false,
            isAuthenticated : false,
            userInfo        : null
            })
        }
        case actionType.SERVICE_USERINFO_ERROR :
        return Object.assign({}, state, {
            isFetching: false,
            errorMessage: action.error || null,
            isAuthenticated: false
        });
        //LISTA AZIENDE
        case actionType.SERVICE_AZIENDE_TUPLA_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching : true
            })
        case actionType.SERVICE_AZIENDE_TUPLA_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching    : false,
                aziendeList   : typeof action.response === 'undefined' ? [] : action.response,
                authenticated : action.authenticated || false
            })
        case actionType.SERVICE_AZIENDE_TUPLA_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching   : false,
                errorMessage : action.error || null
            })
        //LISTA IMPIANTI
        case actionType.SERVICE_IMPIANTI_TUPLA_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching : true
            })
        case actionType.SERVICE_IMPIANTI_TUPLA_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching    : false,
                impiantiList  : typeof action.response === 'undefined' ? [] : action.response,
                authenticated : action.authenticated || false
            })
        case actionType.SERVICE_IMPIANTI_TUPLA_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching   : false,
                errorMessage : action.error || null
            })

        /*
        *   GESTIONE LISTA FILTRI
        */
        //Lista Campi Personalizzati
        case actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true,
                errorMessage : null
            })
        case actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching               : false,
                campiPersonalizzatiList  : action.response,
            })
        case actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        //AGGIUNGI FILTRO ALLA LISTA
        case actionType.SERVICE_PESATA_ADD_FILTER :
            //CONTROLLO SE E" IDHOLDING O IDAZIENDA
            var toAdd = true;
            if(action.filtro.CampoTabella === "IDHolding"){
                state.listaFiltri.forEach( f => {if(f.CampoTabella === "IDHolding") {f.Filtro = action.filtro.Filtro; toAdd = false } } )
            }else if(action.filtro.CampoTabella === "IDAzienda"){
                state.listaFiltri.forEach( f => {if(f.CampoTabella === "IDAzienda") {f.Filtro = action.filtro.Filtro; toAdd = false } } )
            }else if(action.filtro.CampoTabella === "IDImpianto"){
                state.listaFiltri.forEach( f => {if(f.CampoTabella === "IDImpianto") {f.Filtro = action.filtro.Filtro; toAdd = false } } )
            }
            if(toAdd) state.listaFiltri.push(action.filtro);

            return Object.assign({}, state, {
                listaFiltri : state.listaFiltri
            })
        case actionType.SERVICE_PESATA_REMOVE_FILTER :
            var newList = state.listaFiltri.filter( (item, i) => i !== action.index );
            return Object.assign({}, state, {
                listaFiltri : newList
            })
        //Lista filtri
        case actionType.SERVICE_PESATE_GET_FILTER_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_PESATE_GET_FILTER_SUCCESS :
        console.log(action.response)
            return Object.assign({}, state, {
                isFetching               : false,
                errorMessage             : null,
                listaFiltri              : action.response
            })
        case actionType.SERVICE_PESATE_GET_FILTER_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        //Lista Operatori Logici
         case actionType.SERVICE_FILTER_LOGICAL_OPERATOR_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_FILTER_LOGICAL_OPERATOR_SUCCESS :
            return Object.assign({}, state, {
                isFetching               : false,
                logicalOperators         : action.response
            })
        case actionType.SERVICE_FILTER_LOGICAL_OPERATOR_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        //Setta lista filtri
        case actionType.SERVICE_PESATE_SET_FILTER :
            return Object.assign({}, state, {
                isFetching: true,
                listaFiltri : action.list
            })
         case actionType.SERVICE_PESATE_SET_FILTER_REQUEST :
            return Object.assign({}, state, {
                isFetching: true,
            })
        case actionType.SERVICE_PESATE_SET_FILTER_SUCCESS :
            return Object.assign({}, state, {
                isFetching               : false,
                dialogFilterOpened       : false,
                pesateList               : action.response
                
            })
        case actionType.SERVICE_PESATE_SET_FILTER_ERROR :
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null
            })
        case actionType.SERVICE_PESATE_DIALOG_FILTRI_CLOSE :
            return Object.assign({}, state, {
                isFetching : false,
                dialogFilterOpened       : false,
                errorMessage : action.error || null
            })
        case actionType.SERVICE_PESATE_DIALOG_FILTRI_OPEN :
            return Object.assign({}, state, {
                isFetching : false,
                dialogFilterOpened       : true,
                errorMessage : action.error || null
            })
        //Dettaglio Pesata
        case actionType.SERVICE_PESATE_DETAILS_REQUEST :
            return Object.assign({}, state, {
                isFetching: true,
                errorMessage : null
            })
        case actionType.SERVICE_PESATE_DETAILS_SUCCESS :
            return Object.assign({}, state, {
                isFetching               : false,
                detailDialogOpened       : true,
                detailDialogPesata       : action.response,
            })
        case actionType.SERVICE_PESATE_DETAILS_ERROR :
            return Object.assign({}, state, {
                isFetching         : false,
                detailDialogOpened : false,
                errorMessage       : action.error || null
            })
        case actionType.SERVICE_PESATE_DETAILS_CLOSE:
            return Object.assign({}, state, {
                isFetching         : false,
                errorMessage       : null,
                detailDialogOpened : false,
                detailDialogPesata : null
            })
        //Lista tipi di file per il download
        case actionType.SERVICE_PESATE_FILE_TYPE_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching: true,
                errorMessage : null
            })
        case actionType.SERVICE_PESATE_FILE_TYPE_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching               : false,
                downloadDialogOpened     : true,
                fileTypeList             : action.response,
            })
        case actionType.SERVICE_PESATE_FILE_TYPE_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching           : false,
                downloadDialogOpened : false,
                errorMessage         : action.error || null
            })
        case actionType.SERVICE_PESATE_FILE_TYPE_LIST_CLOSE : 
            return Object.assign({}, state, {
                isFetching           : false,
                downloadDialogOpened : false,
                errorMessage         : null
            }) 
        //
        case actionType.SERVICE_PESATE_FILE_DOWNLOAD_REQUEST :
            return Object.assign({}, state, {
                isFetching: true,
                errorMessage : null
            })
        case actionType.SERVICE_PESATE_FILE_DOWNLOAD_SUCCESS :
            var fileDownload = require('js-file-download');
            fileDownload(action.response, 'filename.csv');
            return Object.assign({}, state, {
                isFetching      : false,
                file            : action.response,
                errorMessage    : null
            })
        case actionType.SERVICE_PESATE_FILE_DOWNLOAD_ERROR :
            return Object.assign({}, state, {
                isFetching           : false,
                errorMessage         : action.error || null
            })
        default:
            return state;
    }
};

export default pesataReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_Pesata.js